import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow-button.svg'


const _withScopeId = n => (_pushScopeId("data-v-4c641db3"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-slick-arrow",
  style: {"left":"8px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "custom-slick-arrow",
  style: {"right":"8px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
    /*#__PURE__*/_createElementVNode("img", {
      style: { rotate: '180deg' },
      src: _imports_0
    })
  ])
], -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dots-filler" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Carousel, { arrows: "" }, {
      prevArrow: _withCtx(() => [
        _hoisted_1
      ]),
      nextArrow: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topImages, (topImage, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("img", {
              src: topImage.fileUrl
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topImages, (_, index) => {
        return (_openBlock(), _createElementBlock("li", { key: index }))
      }), 128))
    ])
  ]))
}